export default __webpack_public_path__ + "static/media/nav-metrics-fill.56efd398.svg";